// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3ZZxv","modalForm":"UpgradeEpcsModal_modalForm__oZ02-","modalFooter":"UpgradeEpcsModal_modalFooter__ApRXk"};